import type { KeyboardEvent } from 'react';

/**
 * Accessible clickable-element props (E13-04). A non-button element used as a button — a `<tr>`/`<div>`
 * drill-down row or accordion header — must be keyboard-operable (focusable + Enter/Space activate), or
 * keyboard and screen-reader users can't use it. This packages the exact pattern the dashboard proved into
 * one place so every clickable row behaves identically. Spread it: `<tr {...rowButton(() => open(id))}>`.
 */
export function rowButton(onActivate: () => void): {
  role: 'button';
  tabIndex: 0;
  onClick: () => void;
  onKeyDown: (e: KeyboardEvent) => void;
} {
  return {
    role: 'button',
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onActivate();
      }
    },
  };
}
